import React from "react";
import { LeadLink } from "web/react/components/lead-link";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack";
import { AffiliateBuyButton } from "web/react/pages/product/in-stock/in-stock-product-page/buy-button/";
import { gettext } from "web/script/modules/django-i18n";
import { ProductBuyOptionsSerializer } from "web/types/serializers";
import * as styles from "./express-checkout-disclaimer.css";

interface ExpressCheckoutDisclaimerProps {
    productId: string;
    buyOption: ProductBuyOptionsSerializer;
}

export function ExpressCheckoutDisclaimer({
    productId,
    buyOption,
}: ExpressCheckoutDisclaimerProps): JSX.Element {
    return (
        <VStack spacing="sm">
            <AffiliateBuyButton
                buttonProps={{
                    title: gettext("product.buy_area.buy_direct_btn_text"),
                    variant: "secondary",
                }}
                buyOption={buyOption}
                contextType={"comparison_option"}
            />
            <Text as={"span"} className={styles.or} textStyle={"caption-1"}>
                {gettext("in_stock_product.or_separator")}
            </Text>
            <LeadLink
                href={buyOption.affiliate_url}
                productId={productId}
                openInNewTab={true}
                reason="retailer-ec-disclaimer"
            >
                <Text as={"span"} textStyle={"body-s-bold"}>
                    <span className={styles.copy}>
                        {gettext("product.buy_area.size_stock_disclaimer", {})}
                    </span>
                    {buyOption.retailer_name}
                </Text>
            </LeadLink>
        </VStack>
    );
}
